// import { combineReducers } from 'redux';
import { GET_TRAIN_FAULTS_SUCCESS, GET_TRAIN_FAULTS_FAILED } from '../actions/types';


const initialState = {
    CustomerTrainFaults: {},
    stationList: []
}

const CustomerTrainFaultReduer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TRAIN_FAULTS_SUCCESS:
            return {
                ...state,
                CustomerTrainFaults: action.response.body,
                stationList : action.response.body.station_list
            }

        case GET_TRAIN_FAULTS_FAILED:
            return {
                ...state,
                CustomerTrainFaults: {}
            }

        default:
            return state
    }
}

export default CustomerTrainFaultReduer